import React from 'react';
import './DataListFilter.css';
import DataFilter from '../DataFilter/DataFilter';


const DataListFilter = <T,>() => {

	return (
		<div className="DataListFilter" data-testid="DataListFilter" id="DataListFilter">
				<DataFilter isModal parentId="DataListFilter"/>
		</div>
	);
}

export default DataListFilter;